import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export function Canvas({ onCanvasMount, fill = false, className, }) {
    if (fill) {
        return (_jsx(FillCanvas, { ref: onCanvasMount, width: 1920, height: 1080, className: className }));
    }
    return (_jsx("canvas", { ref: onCanvasMount, width: 1920, height: 1080, className: className }));
}
const FillCanvas = styled.canvas `
    width: 100% !important;
    height: 100% !important;
    display: block;
    object-fit: fill; /* Stretch to fill, ignore aspect ratio */
`;
